import React, { useState } from "react";
import { auth } from "../firebaseConfig";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  updateProfile, // ✅ Import updateProfile
} from "firebase/auth";
import { useNavigate } from "react-router-dom"; // ✅ Import useNavigate
import "./css/login.css";
import { motion } from "framer-motion";

const LoginSignup = () => {
  const navigate = useNavigate(); // ✅ React Router Hook
  const [isLogin, setIsLogin] = useState(true); // Default is Login
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState(""); // ✅ Capture user's name
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Handle Sign In & Sign Up
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      if (isLogin) {
        // ✅ Login Logic
        await signInWithEmailAndPassword(auth, email, password);
        localStorage.setItem("user", "true"); // ✅ Store session
        navigate("/"); // ✅ Redirect to Home
        window.location.reload(); // ✅ Refresh UI
      } else {
        // ✅ Signup Logic with Name
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;

        // ✅ Update user profile with display name
        await updateProfile(user, { displayName: name });

        alert("Signup Successful! Please login.");
        setIsLogin(true); // ✅ Switch to Login mode
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      className="login-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className={`login-box ${isLogin ? "login-mode" : "signup-mode"}`}
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Left Side with Welcome Message */}
        <motion.div
          className="login-left"
          initial={{ x: -100 }}
          animate={{ x: 0 }}
          transition={{ duration: 0.5 }}
        >
         {/* <img src="/assets/lifoura-04.png" alt="LifeVault Logo" className="logo-image" /> */}
          <h2>{isLogin ? "Welcome Back!" : "Start Your Memory Journey"}</h2>
          <p>
            {isLogin
              ? "Log in to continue your journey with us."
              : "Create an account and explore our amazing features."}
          </p>
          {/* Toggle Between Login & Signup */}
          <motion.button
            className="toggle-btn"
            onClick={() => setIsLogin(!isLogin)}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            {isLogin ? "Create an Account" : "Already have an account? Log in"}
          </motion.button>
        </motion.div>

        {/* Right Side with Form */}
        <motion.div
          className="login-right"
          initial={{ x: 100 }}
          animate={{ x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h2>{isLogin ? "Login" : "Sign Up"}</h2>
          {error && <p className="error-text">{error}</p>}
          <form onSubmit={handleSubmit}>
            {!isLogin && (
              <div className="input-group">
                <input
                  type="text"
                  placeholder="Enter Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            )}
            <div className="input-group">
              <input
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <input
                type="password"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <motion.button
              type="submit"
              className="btn-login"
              disabled={loading}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              {loading ? "Processing..." : isLogin ? "Login" : "Sign Up"}
            </motion.button>
          </form>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default LoginSignup;
